import { Flex } from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { componentState } from "../../atoms/componentState";
import { openConfirmTerms } from "../../atoms/openConfirmTerms";
import { dateForAPI } from "../../constants/dataFormat";
import CardSaldo from "./components/cardSaldo";
import CarouselComponent from "./components/dashboardCarousel";
import SalesListDashboard from "./components/SalesListDashboard";
import SalesSimulator from "./components/salesSimulator";
import Simulator from "./components/simulator";
import TablesComponent from "./components/tablesComponent";
import ModalConfirmationTerms from "./defaultComponents/modalConfirmationTerms";
import { customColors } from "../../atoms/customColors";
import { permissions } from "../../atoms/permissions";

interface Permission {
  idPermissoes: number;
  idCliente: number;
  permissao: string | null;
  cliente: string | null;
}

function Dashboard() {
  const setHeaderLocation = useSetRecoilState(componentState);
  const [isOpen, setIsOpen] = useState(false);
  const dataInicio = moment(Date()).startOf("day").format(dateForAPI);
  const dataFim = moment(Date()).endOf("day").format(dateForAPI);

  const colors = useRecoilValue(customColors);
  const userPermissions = useRecoilValue<Permission[]>(permissions);
  const setOpenTerms = useSetRecoilState(openConfirmTerms);
  const openTerms = useRecoilValue(openConfirmTerms);

  const [dateF, setDateF] = useState(dataFim);
  const [dateI, setDateI] = useState(dataInicio);

  useEffect(() => {
    setHeaderLocation("Dashboard");
  }, [setHeaderLocation]);

  // Verificação de permissão
  const requiredPermissions = [1, 39];
  const hasPermission = userPermissions.some((permission) =>
    requiredPermissions.includes(permission.idPermissoes)
  );

  return (
    // Layout em duas colunas fluidas no lugar de 59vw + 25vw fixos:
    // - abaixo de 80em (4:3 de 1024, janela estreita) as colunas empilham,
    //   em vez de espremer os cards a ponto de cortar conteúdo;
    // - a coluna lateral tem largura em clamp, então não some em tela pequena
    //   nem vira um vazio de 600px num ultrawide;
    // - as alturas viraram minH em px: com 12vh/27vh/42vh, um ultrawide de
    //   1080p (ou um 4:3 de 768) achatava tabela e gráfico até ficarem ilegíveis.
    <Flex
      width="100%"
      h={"90vh"}
      overflowY={"auto"}
      overflowX={"hidden"}
      justifyContent={"center"}
    >
      <Flex
        w={"100%"}
        maxW={"1800px"}
        px={{ base: 3, md: 5, "2xl": 8 }}
        py={{ base: 3, md: 4 }}
        gap={{ base: 4, xl: 6 }}
        alignItems={"flex-start"}
        flexDir={{ base: "column", xl: "row" }}
      >
        <Flex
          flex={"1 1 0"}
          minW={0}
          w={"100%"}
          flexDir={"column"}
          alignItems="center"
          gap={{ base: 3, md: 4 }}
        >
          <Flex
            bgColor={colors.BLUEMONEDDBUTTONS}
            w={"100%"}
            minH={{ base: "96px", md: "120px" }}
            py={3}
            flexDir={"column"}
            alignItems="center"
            justifyContent="center"
            borderRadius={"15px"}
          >
            <CardSaldo />
          </Flex>
          <Flex
            w={"100%"}
            minH={{ base: "260px", md: "300px" }}
            flexDir={"column"}
            alignItems="center"
          >
            <TablesComponent
              dateF={dateF}
              setDateF={setDateF}
              dateI={dateI}
              setDateI={setDateI}
            />
          </Flex>
          <Flex
            w={"100%"}
            minH={{ base: "380px", md: "440px" }}
            flexDir={"column"}
            alignItems="center"
          >
            <SalesListDashboard
              dateF={dateF}
              setDateF={setDateF}
              dateI={dateI}
              setDateI={setDateI}
            />
          </Flex>
        </Flex>

        <Flex
          w={{ base: "100%", xl: "clamp(280px, 24vw, 400px)" }}
          flexShrink={0}
          flexDir={"column"}
          alignItems={"center"}
          gap={{ base: 4, xl: 8 }}
          pb={{ base: 4, xl: 8 }}
        >
          <CarouselComponent />
          {hasPermission && <Simulator setIsOpen={setIsOpen} />}
        </Flex>
      </Flex>

      <SalesSimulator isOpen={isOpen} setIsOpen={setIsOpen} />
      <ModalConfirmationTerms isOpen={openTerms} setIsOpen={setOpenTerms} />
    </Flex>
  );
}

export default Dashboard;
